import React from 'react'
import '../styles/index.scss'
import ListPeriodsPage from './ListPeriodsPage'

function ListPeriodsContainer() {
    return (
        <div className='ListPeriodsContainer'>
            <ListPeriodsPage />
        </div>
    )
}

export default ListPeriodsContainer